import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "scene-background" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraOverlay = _resolveComponent("CameraOverlay")!
  const _component_DevControls = _resolveComponent("DevControls")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Cookies = _resolveComponent("Cookies")!
  const _component_YouTubeFullscreen = _resolveComponent("YouTubeFullscreen")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('wrapper route-name-' +  $setup.currentRoute)
  }, [
    _createVNode(_component_CameraOverlay),
    ($setup.config.development)
      ? (_openBlock(), _createBlock(_component_DevControls, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (!_ctx.$store.state.cookiesAccepted)
      ? (_openBlock(), _createBlock(_component_Cookies, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_YouTubeFullscreen),
    _hoisted_1
  ], 2))
}